import { GET_MOUVEMENTS_OR, DELETE_MOUVEMENT_OR } from '../actions/action-types';

const initialState = {
  liste: [],
  loadedAt: null
};

export default function mouvementsOrReducer(state = initialState, action) {
  switch (action.type) {
    case GET_MOUVEMENTS_OR:
      return { ...state, liste: action.payload, loadedAt: Date.now() };
    case DELETE_MOUVEMENT_OR:
      return { ...state, liste: state.liste.filter(m => m.id !== action.payload) };
    default:
      return state;
  }
}
